import {classNames, observer, Popover2, useAsObservableSource, _, React} from '@api'
import {Menu, MenuDivider} from '@blueprintjs/core'
import {ListItem, ListItemText} from '@material-ui/core'
import {BoardFilterGroup, CatalogLibrariesStore, useCatalogLibrariesStore, useVipLocalStore, VipLocalStore} from '@modules'
import {ICatalogFieldConfig, StoresInstance} from '@stores'
import {action, computed} from 'mobx'
import * as css from './AssignableLibraryField.css'

type AssignableLibraryFieldStoreProps = {
  field: ICatalogFieldConfig
  store: CatalogLibrariesStore
}

export class AssignableLibraryFieldStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props?: AssignableLibraryFieldStoreProps) {
    super(stores)
  }

  @computed get sectionConfig() {
    return this.catalog.sectionConfigFor(this.props.field?.section)
  }

  @computed get sectionValues() {
    return this.catalog.sectionValuesFor(this.props.field?.section)
  }

  @computed get fieldLabel() {
    return this.catalog.labelForFieldName_currentCatalog(this.props.field?.field)
  }

  @computed get hasCount() {
    return _.isNumber(this.count)
  }

  @computed get canFilter() {
    return !_.isEmpty(this.filterGroup?.groupedByValue)
  }

  @computed get filterGroup() {
    return this.stores.filter.groupFor(this.props.field?.field)
  }

  @computed get count() : number {
    const {sectionConfig, props: {store: {countById}, field: {field, def, agg: fieldAgg}}, catalog: {groupBy: {counts}}, c8} = this

    if (def?.type === 'Boolean' || fieldAgg === 'exists') {
      return 2
    }

    if (def?.type === 'Enum' || def?.type === 'EnumList') {
      const r = def.enumValues?.length ?? c8.enumByName.get(def.enumType)?.length
      if (_.isNumber(r)) return r
    }

    if (def?.type === 'Tag' || def?.type === 'TagList') {
      if (!def.tagType) return null

      return Number(_.get(countById, `assignableFields.${def.tagType}.doc_count`))
    }

    return sectionConfig?.viewOptions?.field ? (countById[field] ? countById[field]?.count?.value : null)
                                             : (countById[field]?.value ?? countById[field]?.doc_count ?? counts[field]?.value)
  }

  @action onContextMenu = e => {
    this.props.store.onContextMenu(e, this.props)
  }
}

export const AssignableLibraryFieldContext = React.createContext<AssignableLibraryFieldStore>(null)
export const useAssignableLibraryField = () => React.useContext(AssignableLibraryFieldContext)

export const AssignableLibraryField = observer<{ field: ICatalogFieldConfig, className?: string }>(function AssignableLibraryField({className, field: f}) {
  const parentStore = useCatalogLibrariesStore(),
    {sidebar: {navigateToLibrary}} = parentStore

  //const obsProps = useAsObservableSource({field: f, parentStore}), // Blows up with context menu - unsure why
    const {strings, catalog, onContextMenu, fieldLabel, hasCount, canFilter, filterGroup, sectionValues, count, props: {field: {field, esIndex, section}}} = useVipLocalStore((ws) => new AssignableLibraryFieldStore(ws, {field: f, store: parentStore}))

  // logJS({field, section, count, counts: parentStore.countById})

  return (
    <ListItem button
              classes={{root: classNames(className, css.listItem)}}
              data-field={field}
              data-can-filter={canFilter}
              data-has-count={hasCount}
              data-workspace={f.workspace ?? catalog.workspaceByIndex[esIndex]?._id}
              data-section={section}
              data-is-filtering={filterGroup && (filterGroup.selected?.size > 0 || filterGroup.excluded?.size > 0)}
              onContextMenu={onContextMenu}
              onClick={() => navigateToLibrary({libraryId: field}, true)}>
      <ListItemText
        classes={{
          root: css.listItemText,
          primary: css.primaryText,
          secondary: css.secondaryText
        }}

        primary={fieldLabel}
        //<div className={css.labelAndSection}>
        //                      <span className={css.label}>{catalog.labelForFieldName_currentCatalog(field)}</span>
        //                      {sectionConfig && <Chip className={css.section} label={sectionConfig.label} />}
        //                    </div>
        secondary={hasCount ?
                   <Popover2 interactionKind='hover'
                             disabled={!canFilter}
                             position='right'
                             portalClassName={css.popoverPortal}
                             popoverClassName={classNames(css.filterPopover, 'animate__animated animate__fadeIn')}
                             hoverOpenDelay={290}
                             hoverCloseDelay={300}
                     //modifiers={POPOVER2_NO_ARROW}
                             content={<Menu className={css.assignableFieldPopoverMenu}>
                               <MenuDivider className={css.filterTitle} title={`${strings.filter} '${fieldLabel}'`}/>
                               <BoardFilterGroup className={css.filterGroupPopover} noTitle key={field} index={0} field={f} expanded ignoreSection isPopover/>
                             </Menu>}>{`${count * (sectionValues?.length ?? 1)}`}
                   </Popover2> : null}
      />
    </ListItem>
  )
});



// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/CatalogLibrariesPanel/AssignableLibraryField.tsx